import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const BLEMIDIID = Number.MAX_SAFE_INTEGER
const checkIsSynced = (state={}, idx=null) => {
  const ignoreKeys = ['isSynced', 'fetched']
  if (Object.keys(state).length==0 || idx==null) {
    return false
  }
  const patchNo = idx
  const storedPatch = state.storedPatchList[patchNo]
  const editedPatch = state.editPatchList[patchNo]
  const patchKeys = Object.keys(editedPatch.decoded)
  let retIsSynced = true
  for (let i=0; i<patchKeys.length; i++) {
    const key = patchKeys[i]
    if (ignoreKeys.includes(key)) continue
    const edited = editedPatch.decoded[key]
    const stored = storedPatch.decoded[key]
    const isSynced = (JSON.stringify(edited) == JSON.stringify(stored))
    //console.log(key, isSynced, `edited=[${JSON.stringify(edited)}] stored=[${JSON.stringify(stored)}]`)
    if (isSynced == false) {
      retIsSynced = isSynced
      console.log(typeof state.editPatchList[patchNo].decoded.isSynced, state.editPatchList[patchNo].decoded.isSynced)
      console.log(`\u001b[31midx=[${idx}] key=[${key}] isSynced=[${isSynced}] edit=[${JSON.stringify(edited)}] stored=[${JSON.stringify(stored)}] ${JSON.stringify(edited) == JSON.stringify(stored)}`)
      break
    }
  }
  return retIsSynced
}

export default new Vuex.Store({
  namespaced: true, // 名前空間を有効にする
  strict: true,
  state: {
    loadingSplashShow: true,
    demoMode: false,
    isValidationOK: true,
    enableControl: false,
    config: {
      midi_device: { input: null, output: null }
    },
    workingPatch: {
      idx: null,
      tmp: {
        link: {
          oscFilter: false,
          noiseFilter: false
        }
      }
    },
    storedPatchList: new Array(100).fill({}),
    editPatchList: new Array(100).fill({}),
    statusExpandPanel: [], // open/close panel
  },
  getters: {
    getIsValidationOK: (state) => () => {
      return state.isValidationOK
    },
    getEnableControl: (state) => () => {
      return state.enableControl
    },
    getLoadingSplashShow: (state) => () => {
      return state.loadingSplashShow
    },
    getDemoMode: (state) => () => {
      return state.demoMode
    },
    // open/close panel
    getStatusExpandPanel: (state) => () => {
      return state.statusExpandPanel
    },
    getWorkingPatchIdx: (state) => () => {
      return state.workingPatch.idx
    },
    getWorkingPatchFilterLink: (state) => (name) => {
      //return state.workingPatch.tmp.link[name]
      const idx = state.workingPatch.idx
      if (typeof state.editPatchList[idx].decoded[`${name}Link`]=='undefined') {
        // [COMMENT]
        // state.editPatchList[idx].fetched is status NOT for demo mode.
        // this parameter stands for if the target patch is fetched from device in device mode.
        return false
      }
      return (state.editPatchList[idx].decoded[`${name}Link`][0]==1) ? true : false
      //return (state.editPatchList[idx].decoded[`${name}Link`][0]==0) ? true : false
      //return state.workingPatch.tmp.link[name]
    },
    getWorkingPatch: (state) => () => {
      return state.workingPatch
    },
    isUsingBleMIDI: (state) => () => {
      if (state.config.midi_device.input == BLEMIDIID
          && state.config.midi_device.output == BLEMIDIID) {
        return true
      } else {
        return false
      }
    },
    getConfigMidiDeveice: (state) => () => {
      return state.config.midi_device
    },
    getAllStoredPatch: (state) => () => {
      return state.storedPatchList
    },
    getOneStoredPatch: (state) => (idx) => {
      return state.storedPatchList[idx]
    },
    getAllEditedPatch: (state) => () => {
      return state.storedPatchList
    },
    getOneEditPatch: (state) => (idx) => {
      return state.editPatchList[idx]
    },
    getCheckOneEditPatchIsSynced: (state) => (idx=null) => {
      if (idx==null) {
        idx = state.workingPatch.idx
      }
      if (typeof idx != 'number') {
        // return "IS NOT SYNCED" if idx is unknown
        return false
      }
      const retIsSynced = checkIsSynced(state, idx)
      return retIsSynced
    }
  },
  mutations: {
    onUpdateLoadingSplashShow(state, payload) {
      if (payload.value!=true && payload.value!=false) {
        payload.value=false
      }
      Vue.set(state, 'loadingSplashShow', payload.value)
    },
    onUpdateDemoMode(state, payload) {
      Vue.set(state, 'demoMode', payload.value)
      Vue.set(state, 'enableControl', false)
    },
    onUpdateIsValidationOK(state, payload) {
      Vue.set(state, 'isValidationOK', payload.value)
    },
    onUpdateEnableControl(state) {
      Vue.set(state, 'enableControl', true)
    },
    onCheckIsWorkingPatchSynced(state) {
      const workingPatch_idx = state.workingPatch.idx
      const retIsSynced = checkIsSynced(state, workingPatch_idx)
      Vue.set(state.editPatchList[workingPatch_idx].decoded, 'isSynced', retIsSynced)
    },
    onEditOneEditPatch(state, payload={arr_idx:[], value:null}) {
      if (payload.arr_idx.length<=0 || payload.value==null) return
      const workingPatch_idx = state.workingPatch.idx

      // [TODO] 全パラメータを確認する必要あり
      if (payload.arr_idx.length==2) {
        if (JSON.stringify(state.storedPatchList[workingPatch_idx].decoded[payload.arr_idx[0]][payload.arr_idx[1]]) != JSON.stringify(payload.value)) {
          console.log('[store.js: onEditOneEditPatch]', state.storedPatchList[workingPatch_idx].decoded[payload.arr_idx[0]][payload.arr_idx[1]], payload.value)
          Vue.set(state.editPatchList[workingPatch_idx].decoded, 'isSynced', false)
          //state.editPatchList[workingPatch_idx].decoded.isSynced = false
        }
        Vue.set(state.editPatchList[workingPatch_idx].decoded[payload.arr_idx[0]], payload.arr_idx[1], payload.value)
      } else
      if (payload.arr_idx.length==1) {
        if (JSON.stringify(state.storedPatchList[workingPatch_idx].decoded[payload.arr_idx[0]]) != JSON.stringify(payload.value)) {
          console.log('[store.js: onEditOneEditPatch]', JSON.stringify(state.storedPatchList[workingPatch_idx].decoded[payload.arr_idx[0]]) == JSON.stringify(payload.value))
          console.log('[store.js: onEditOneEditPatch]', JSON.stringify(state.storedPatchList[workingPatch_idx].decoded[payload.arr_idx[0]]), JSON.stringify(payload.value))
          Vue.set(state.editPatchList[workingPatch_idx].decoded, 'isSynced', false)
          //state.editPatchList[workingPatch_idx].decoded.isSynced = false
        }
        Vue.set(state.editPatchList[workingPatch_idx].decoded, payload.arr_idx[0], payload.value)
      }
    },
    onInitPatchList(state, payload) {
      state.storedPatchList = JSON.parse(JSON.stringify(payload.data))
      state.editPatchList = JSON.parse(JSON.stringify(payload.data))
    },
    onUpdateStatusExpandPanel(state, payload) {
      Vue.set(state, 'statusExpandPanel', payload.value)
    },
    onSetWorkingPatchIdx(state, payload) {
      if (state.workingPatch.idx == payload.value) {
        Vue.set(state.workingPatch, payload.idx, 99999)
      }
      Vue.set(state.workingPatch, payload.idx, payload.value)
    },
    onUpdateEditPatch(state, payload) {
      const retIsSynced = checkIsSynced(state, state.workingPatch.idx)
      payload.value.decoded.isSynced = retIsSynced
      Vue.set(state.editPatchList, payload.idx, payload.value)
    },
    onUpdateWorkingPatchFilterLink(state, payload) {
      const working_idx = state.workingPatch.idx
      let link_val = {0: 1} // true
      if (payload.value===false) {
        if (state.storedPatchList[working_idx].decoded[`${payload.idx}Link`][0]!=1) {
          link_val = state.storedPatchList[working_idx].decoded[`${payload.idx}Link`]
        } else {
          link_val = {0: 2}
        }
      }
      //console.trace(`payload.value=[${payload.value}] link_val=[${link_val}] working_idx=[${working_idx}]`)
      Vue.set(state.editPatchList[working_idx].decoded, `${payload.idx}Link`, link_val)
      /*
      state.editPatchList.forEach( (item, idx)=> {
        if (idx < 20) {
          console.log(`idx=[${idx}] edit:oscFilterLink=[${JSON.stringify(item.decoded.oscFilterLink)}] stored:oscFilterLink=[${JSON.stringify(state.storedPatchList[idx].decoded.oscFilterLink)}]`)
          console.log(`idx=[${idx}] edit:noiseFilterLink=[${JSON.stringify(item.decoded.noiseFilterLink)}] stored:noiseFilterLink=[${JSON.stringify(state.storedPatchList[idx].decoded.noiseFilterLink)}]`)
        }
      })
      */
      //const link_state_now =
      //  state.editPatchList[working_idx].decoded[`${payload.idx}Link`][0] == 1 ? true : false
      //console.log(`now=[${link_state_now}] will=[${payload.value}]`)
      //if (link_state_now != payload.value) {
      //}
      /*
      switch(payload.idx) {
        case 'oscFilter':
          state.editPatchList[working_idx]
               .decoded.oscFilter1Decoded.link =
                 state.editPatchList[working_idx]
                      .decoded.oscFilter1Decoded.link =
                        payload.value
          //Vue.set(state.editPatchList[working_idx].decoded, `${payload.idx}Link`, payload.value==1? true : fasle)
          //console.trace(state.editPatchList[working_idx].decoded.oscFilter1Decoded.link)
          break
        case 'noiseFilter':
          state.editPatchList[working_idx]
               .decoded.noiseFilter1Decoded.link =
                 state.editPatchList[working_idx]
                      .decoded.noiseFilter1Decoded.link =
                        payload.value
          break
      }
      Vue.set(state.workingPatch.tmp.link, payload.idx, payload.value)
      */
    },
    onDiscardSelectedPatch(state, payload) {
      const patchNo = typeof payload.idx != 'undefined' ? payload.idx : state.workingPatch.idx
      const storedPatch = JSON.parse(JSON.stringify(state.storedPatchList[patchNo]))
      console.log(patchNo, storedPatch.decoded.patchNameDecoded)
      Vue.set(state.editPatchList, patchNo, storedPatch)

      //Vue.set(state.editPatchList, patchNo, storedPatch)
      //console.log(patchNo, state.editPatchList[patchNo].decoded.patchNameDecoded)
      //console.error(patchNo, state.editPatchList[patchNo].decoded.osc1Decoded)
    },
    onUpdateSelectedMidiDevice(state, payload) {
      if (payload.type == 'blemidi') {
        Vue.set(state.config.midi_device, 'input', BLEMIDIID)
        Vue.set(state.config.midi_device, 'output', BLEMIDIID)
      } else {
        Vue.set(state.config.midi_device, payload.type, payload.idx)
      }
    },
    onSetStoredPatchList(state, payload) {
      Vue.set(state.storedPatchList, payload.idx, payload.value)
    },
    onSetEditPatchList(state, payload) {
      Vue.set(state.editPatchList, payload.idx, payload.value)
    },
  },
})
